import {Component} from '@angular/core';

@Component({
  selector: 'ngx-task',
  template: `
    <router-outlet></router-outlet>`,
})
export class TaskComponent {
}
